
import { Component, Prop, Vue } from 'vue-property-decorator';
import AddressDetails from '@/components/views/NewProjectView/AddressDetails.vue';
import GenericDeletePopconfirm from '@/components/global/GenericDeletePopconfirm.vue';
import { Button, Icon, Popconfirm } from 'ant-design-vue';
import { deleteAddressEntity } from '@/helpers/project/AddressHelper';


@Component({
    name: 'AdditionalAddressTopBar',
    components: {AddressDetails, Button, Icon, Popconfirm, GenericDeletePopconfirm},
})
export default class AdditionalAddressTopBar extends Vue {
    @Prop({default: null}) private addressId!: string | null;
    @Prop({default: false}) private isLoading!: boolean;
    @Prop({required: true}) private parentRelationshipName!: string;
    @Prop({required: true}) private parentRelationshipId!: string;
    @Prop({default: false}) private isEditMode!: boolean;
    @Prop({default: null}) private emptyTitle!: string | null;
    @Prop({default: null}) private filledTitle!: string | null;

    private get title() {
        const emptyTitle = this.emptyTitle || this.$t('Nema dodatne adrese');
        const filledTitle = this.filledTitle || this.$t('Podaci o dodatnoj adresi');

        return this.addressId ? filledTitle : emptyTitle;
    }

    private get addressExists() {
        return this.addressId != null;
    }

    private openAddressModal() {
        this.$emit('update:isModalVisible', true);
    }

    private async confirmDeleteAddress() {
        if (this.addressId == null) {
            return;
        }

        this.$emit('update:isLoading', true);
        await deleteAddressEntity(this.addressId, this.parentRelationshipName, this.parentRelationshipId);
        this.$emit('update:isLoading', false);
    }
}
